export default __webpack_public_path__ + "static/media/minus.6696ca76.svg";